'use client';

import { useUser } from '@clerk/nextjs';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  // Clerk provides user data directly via useUser() hook
  // No need to fetch additional profile data from backend
  useUser();

  return <>{children}</>;
}
